import Contact = SPA.Contact;
import AJAXCallbase_e = Wollmilch.AJAXCallbase_e;

class ContactManager
{
	private Company: number;
	private List: SPA.Contacts.ContactList;

	private working: boolean;

	private LastModified: Date;
	// private Observers: Array<([]) => any>;

	public constructor(companyID: number = 0)
	{
		this.Company = companyID;
		this.List = new SPA.Contacts.ContactList();
		this.LastModified = new Date(0);
		this.working = false;
		// this.Observers = [];
	}

	public reset(companyID: number = 0)
	{
		this.Company = companyID;
		this.List = new SPA.Contacts.ContactList();
		this.LastModified = new Date(0);
		this.working = false;
		// this.Observers = [];
	}

	public getContacts()
	{
		return this.List;
	}

	public Count(): number
	{
		return this.List.length;
	}

	public getLastModified(): Date
	{
		return this.LastModified;
	}

	public getCompany(): number
	{
		return this.Company;
	}

	public setCompany(companyID: number): void
	{
		this.Company = companyID;
	}

	public getItems(object_number?: string, name?: SPA.IContactStatusName): SPA.Contact[]
	{
		const results = this.List.models.filter((c) => {
			const list = c.StatusList.findStatus({name, object_number});
			return list && list.length !== 0;
		});

		return results;
	}

	public buildDeleteButton(status: SPA.ContactStatus, callback: (resp: any) => void): JQuery
	{
		const btnDelete = $(`
			<button class="btn btn-default btm-sm" style="margin-right:5px">
				<i class="fas fa-trash"></i>
				<span>Löschen</span></button>`
		)
			.on('click', () => {
				const contact = this.getItem(status.ContactID);
				if (contact) {
					contact.unlink(status.StatusID, callback);
				}
			});

		return btnDelete;
	}

	public link(ContactID: number, ObjectNumber: string, statusName: SPA.IContactStatusName, callback?: (status: SPA.ContactStatus) => void)
	{
		const contact = this.getItem(ContactID);
		if (!contact)
		{
			app.addNotify(
				{
					context: "danger",
					body: [$('<p>Fehler beim Zuweisen des Kontaktes.<br>Der Kontakt wurde nicht gefunden.</p>')],
					timeout: Number(app.getConfigValue("ToastTimeout")),
					title: ['Fehler bei Kontakt']
				}
			);
			return;
		}

		contact.link(ObjectNumber, statusName, callback);
	}

	public updateContacts(callback: ((data: Wollmilch.Realtor.Object[]) => any) | null = null, update: boolean = false, force: boolean = false)
	{
		if (this.Company === 0)
		{
			return;
		}

		// if (callback) {
		// 	this.Observers.push(callback);
		// }

		if (this.working) {
			return;
		}
		this.working = true;

		if (!force && this.LastModified > new Date(0)) {
			this.working = false;
			// this.processListener();

			return;
		}

		new Wollmilch.AJAX(
			{
				method: 'GET',
				url: 'contact/list',
				on:
					{
						success: (text: string) => {
							const obj = JSON.parse(text);

							for (const row of obj.data)
							{
								const contact = new SPA.Contact(row);
								this.List.add(contact);
							}

							this.LastModified = new Date();
						}
					}
			}, AJAXCallbase_e.REALTOR
		).send();
	}

	public createItem(data: SPA.IContact, callback?: (data: SPA.Contact) => void)
	{
		new Wollmilch.AJAX({
			url: 'contact/create',
			data,
			method: 'POST',
			on: {
				success: (text) => {
					const response: Wollmilch.ResponseObject = JSON.parse(text);

					// Show error if any
					if (!response.success) {
						app.addNotify(
							{
								context: "danger",
								body: [$('<p>Fehler beim Anlegen des Kontaktes.<br>Bitte probieren Sie es später erneut.</p>')],
								timeout: Number(app.getConfigValue("ToastTimeout")),
								title: ['Fehler beim Speichern']
							}
						);
						return;
					}

					// Add new contact
					const contact = new SPA.Contact(response.data);
					this.List.add(contact);

					const salutation = SPA.types.Salutation[contact.Salutation as keyof typeof SPA.types.Salutation];
					app.addNotify(
						{
							context: "success",
							body: [$(`<p>Der Kontakt <strong>${salutation} ${contact.Name} ${contact.Surname}</strong> wurde erfolgreich angelegt.</p>`)],
							timeout: Number(app.getConfigValue("ToastTimeout")),
							title: ['Neuer Kontakt angelegt']
						}
					);

					if (callback !== undefined) {
						callback(contact);
					}
				}
			}
		}, AJAXCallbase_e.REALTOR).send();
	}

	public getItem(ContactID: number)
	{
		const contact = this.List.get(ContactID);
		return contact;
	}

	public addContact(contact: SPA.Contact)
	{
		this.List.add(contact);
	}

	public updateStatus(contact: SPA.Contact)
	{
		for (const idx in this.List.models)
		{
			if (this.List.models[idx].ContactID === contact.ContactID)
			{
				// Todo Update Contact-Data as well?
				this.List.models[idx].Status = contact.Status;
				console.log("Kontakt-Status erfolgreich aktualisiert")
				break;
			}
		}
	}

	public setItemDemand(id: number, demand: any)
	{
		const contact = this.getItem(id);
		contact.Demand = demand;
	}

	public saveDemand(id: number, data: any, callback: ((data: any) => void) | null = null)
	{
		const contact = this.getItem(id);

		new Wollmilch.AJAX({
			url: 'contact/update/' + contact.ContactID,
			method: 'POST',
			data,
			on: {
				success: (text) => {
					const json = Wollmilch.jsonize(text) as Wollmilch.ResponseObject;
					if (json.success === false) {
						app.addNotify(
							{
								context: "danger",
								body: [$('<p>Fehler beim Speichern der Kontaktdetails.<br>Bitte probieren Sie es später erneut.<br><br>Fehlercode: <strong>' + json.error.code + '</strong></p>')],
								timeout: Number(app.getConfigValue("ToastTimeout")),
								title: ['Fehler beim Speichern']
							}
						);
						return;
					}
					this.setItemDemand(contact.ContactID, data);

					app.addNotify(
						{
							context: "success",
							body: [$(`<p>Die Kontaktdetails wurden erfolgreich aktualisiert.</p>`)],
							timeout: Number(app.getConfigValue("ToastTimeout")),
							title: ['Kontaktdetails aktualisiert']
						}
					);

					if (callback)
					{
						callback(data);
					}
				}
			}
		}, AJAXCallbase_e.REALTOR).send();
	}

	public saveDetails(id: number, data: any)
	{
		const contact: SPA.Contact|false = this.getItem(id);
		if (!contact)
		{
			// Todo Message or situation not possible?
			return;
		}

		new Wollmilch.AJAX({
			url: 'contact/updatedetail/' + contact.ContactID,
			method: 'POST',
			data,
			on: {
				success: (text) => {
					const json = JSON.parse(text);
					if (json.success === false) {
						app.addNotify(
							{
								context: "danger",
								body: [$('<p>Fehler beim Speichern der Kontaktdetails.<br>Bitte probieren Sie es später erneut.<br><br>Fehlercode: <strong>' + json.error.code + '</strong></p>')],
								timeout: Number(app.getConfigValue("ToastTimeout")),
								title: ['Fehler beim Speichern']
							}
						);
						return;
					}
					contact.set(json.data);

					// this.setItemDemand(contact.ContactID, data);

					app.addNotify(
						{
							context: "success",
							body: [$(`<p>Die Kontaktdetails wurden erfolgreich aktualisiert.</p>`)],
							timeout: Number(app.getConfigValue("ToastTimeout")),
							title: ['Kontaktdetails aktualisiert']
						}
					);
				},
				failed: (status: number, xhr: jqXHR) => {
					app.addNotify(
						{
							context: "danger",
							body: [$('<p>Fehler beim Speichern der Kontaktdetails.<br>Bitte probieren Sie es später erneut.<br><br>Fehlercode: <strong>' + status + '</strong></p>')],
							timeout: Number(app.getConfigValue("ToastTimeout")),
							title: ['Interner Fehler beim Speichern']
						}
					);
				}
			}
		}, AJAXCallbase_e.REALTOR).send();
	}

	public search(search: string): SPA.Contact[]
	{
		const matches = [];

		for (const contact of this.List.models)
		{
			if (contact.Name.toLowerCase().indexOf(search) !== -1 ||
				contact.Surname.toLowerCase().indexOf(search) !== -1) {
				matches.push(contact);
			}
		}

		return matches;
	}
}
